import React from "react";
import app from "./base";
import HeaderComp from "./home/HeaderComp";
import CurrMarket from "./home/CurrMarket";






const Home = () => {
  return (
  	<div>
      <HeaderComp />
      <CurrMarket />
     
     </div>
  );
};

export default Home;
